var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(!this.$router.history.current.meta.noMainNav)?_c('MainNavigation'):_vm._e(),_c('v-main',{staticStyle:{"height":"100%","background-color":"#ffffff"}},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }